/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UrlaubsanspruecheWithUebertragDto } from '../../models/urlaubsansprueche-with-uebertrag-dto';

export interface GetUrlaubsanspruecheForMitarbeiter$Plain$Params {

/**
 * ID des Mitarbeiter für den die Urlaubsansprüche geholt werden sollen
 */
  mitarbeiterId: string;

/**
 * Jahr für das die Urlaubsansprüche geholt werden sollen
 */
  year?: number;
}

export function getUrlaubsanspruecheForMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: GetUrlaubsanspruecheForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsanspruecheWithUebertragDto>> {
  const rb = new RequestBuilder(rootUrl, getUrlaubsanspruecheForMitarbeiter$Plain.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsanspruecheWithUebertragDto>;
    })
  );
}

getUrlaubsanspruecheForMitarbeiter$Plain.PATH = '/v1/mitarbeiter/{mitarbeiterId}/urlaubsansprueche';
